'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('./styleInject.js');

var css_248z = ".QuestionMark-module_container__HLGU9{height:auto;vertical-align:middle;width:3rem;fill:#000}";
var styles = {"container":"QuestionMark-module_container__HLGU9"};
styleInject["default"](css_248z, '0f0ed74b-63c9-46b0-afbf-53f5143767d0');

exports["default"] = styles;
